﻿// JavaScript Document
(function ($) {
    $(function () {
        //On scroll event hide swipe button
        $(".table-container-m").on("scroll", function () {
            var cur = $(this).scrollLeft();
            if (cur > 45) {
                $(this).find('.swipe-column').hide();
            }
        });
        $(".table-container-m").trigger("scroll");

        //If table are long then 20 rows, position swipe text to the top of the table 
        $('.table-container-m').each(function () {
            var $this = $(this);
            if ($this.find('tr').length > 20) {
                $this.find('.swipe-column').css("vertical-align", "top");
            }
        });
        //Add text to the all table in the class called swipe-column
        if (typeof(swipeText) !== 'undefined') {
            $(".swipe-column").html(swipeText);   
        }


        //if table has srcoll bars
        $('.table-container-m').each(function () {
            if ($(this)[0].scrollWidth > Math.round($(this).width())) {
                $(this).find('.swipe-column').css("display", "table-cell");
            }
            else if ($(window).width() > 768) {
                $(this).find('.swipe-column').css("display", "none");
            }
            else {
                $(this).find('.swipe-column').css("display", "none");
            }
        });

        $(window).resize(function () {
            $('.table-container-m').each(function () {
                if ($(this)[0].scrollWidth > Math.round($(this).width())) {
                    $(this).find('.swipe-column').css("display", "table-cell");
                }
                else if ($(window).width() > 768) {
                    $('.table-container-m').find('.swipe-column').css("display", "none");

                }
                else {
                    $(this).find('.swipe-column').css("display", "none");
                }
            });
            if ($(window).width() > 768) {
                $('body').removeClass('push-right');
                $('body').removeClass('close-body');
                $('body div').removeClass('push-right');
                $('body div').removeClass('close-nav');
                $('#mobile-nav').removeClass('js-ready');
                $('#mobile-nav ul').removeClass('open');
            }
        });

        //open object
        $('.menuBtn').click(function () {
            $('.menu-mobile > ul').toggleClass('open');
            $('.close-nav-b').toggleClass('close-nav');
            $('.push-right').toggleClass('close-body');
            $('.menu-mobile').toggleClass('js-ready');
            $('.mobile-push').toggleClass('push-right');
        });

        $('.close-nav-b').click(function () {
            $('.menu-mobile > ul').toggleClass('open');
            $('.close-nav-b').toggleClass('close-nav');
            $('.close-nav-b').removeClass('nav-hide');
            $(this).addClass('nav-hide');
            $('.push-right').toggleClass('close-body');
            $('.menu-mobile').toggleClass('js-ready');
            $('.mobile-push').toggleClass('push-right');
        });

        $('.mobileBtn').click(function () {
            $(this).toggleClass('open');
            $(this).parent('li').toggleClass('open');
        });

        $('.btn-search-m').click(function () {
            $('.outer-bg-search').toggleClass('open');
            $('.top-search').toggleClass('open');
        });
    });
})(jQuery);
